import { logger } from './logger';

export const reportError = <T extends string>(key: T extends '' ? never : T, error: unknown) => {
  if (error instanceof Error) {
    logger.error(key, error.message, error);
  } else {
    logger.error(key, `${error}`);
  }
};
